<template>
  <b-container fluid>
    <b-row class="mb-3 mt-3">
      <b-col><ViewPathWidget /></b-col>
    </b-row>

    <div v-if="waitScreen" class="d-flex justify-content-center mb-3">
      <b-spinner style="width: 3rem; height: 3rem;"  label="Loading..."></b-spinner>
    </div>

    <Widget v-show="!waitScreen" v-for="(widget, index) in page.widgets" :widget-data="widget" :key="index" ref="childWidgets"/>
  </b-container>
</template>

<script>
import Widget from "./widgets/Widget";
import {mapGetters, mapState} from "vuex";
import DataRequester from "../../datarequester";
import ResultsService from "../../services/ResultsService";
import ViewPathWidget from "./widgets/ViewPathWidget";
import PageNavigator from "../../services/PageNavigator";

export default {
  name: 'DynPage',

  data() {
    return {
      waitScreen: false
    }
  },

  props: {
    widgetData: Object
  },

  components: {
    Widget, ViewPathWidget
  },

  mounted: function () {
//      console.log("Mounted")
    // this.$nextTick(() => {
    //   this.requestChildWidgetsDataRequests()
    // })

    setTimeout(() => {
      this.requestChildWidgetsDataRequests()
      //console.log('timeout ', this.$refs.whatever);
    }, 0)

  },

  computed: {
    ...mapState(['activeSurvey', 'absoluteDrillPath']),
    ...mapGetters(['realmName', 'studyName', 'authToken', 'pageByName', 'completePath']),

    page: function () {
//        console.log("Getting current page")
      let pageName = this.$route.params.pageName
      return this.pageByName(pageName)
    }
  },

  methods: {
    requestChildWidgetsDataRequests() {
      const requester = new DataRequester("unused", this.completePath)

      for(const cw of this.$refs.childWidgets) {
        // console.log(cw);
        cw.requestData(requester);
      }

      this.handleRequests(requester)
    },

    handleRequests(requester) {
      // console.log("--------->Handling requests")
      // console.log(requester)

      this.waitScreen = true
      ResultsService.postDataRequest(this.authToken, this.realmName, this.studyName, requester).then((response) => {
        this.waitScreen = false

        const responsesContainerDTO = response.data

        this.$store.commit('setNodeInfo', responsesContainerDTO.nodeInfo)

        for(const request of requester.getRequests()) {
          const responseDTO = responsesContainerDTO.responses[request.requestId]

          if(responseDTO) {
            request.callback(responseDTO)
          }

          // reflow
          //console.log("Reflow!")

        }

        this.$store.commit('increaseChartRedrawCounter')

      })

    }
  },

  watch: {
    $route: {
      handler() {
        let drillPath = this.$route.params.path
        if(!drillPath) {
          drillPath = ""
        }

        this.$store.commit('setCompleteDrillPath', drillPath)
      },
      immediate: true
    },

    completePath: function (newPath, oldPath) {
      if (newPath && (newPath !== oldPath)) {
        let pageName = this.$route.params.pageName
        PageNavigator.navigateToPage(this.$router, pageName, newPath)
      } else {
        // console.log("They were the same: " + newPath)
      }
    }

  }

}
</script>